import { Repository } from './Repository';

export default class GroupRepository extends Repository {
    constructor() {
        super();

        this.groupRequestPrefix = '/api/v1/group';
    }

    getGroups = (url) => {
        return this.getRequestPromise('get', this.groupRequestPrefix + `${url}`);
    };

    addGroup = (param) => {
        return this.getRequestPromise('post', this.groupRequestPrefix + `/`, param);
    }

    updateGroup = (groupId, param) => {
        return this.getRequestPromise('put', this.groupRequestPrefix + `/${groupId}`, param);
    }

    getGroup = (groupId) => {
        return this.getRequestPromise('get', this.groupRequestPrefix + `/${groupId}`);
    }

    getLocalGroups = (localeCode) => {
        return this.getRequestPromise('get', this.groupRequestPrefix + `/locale-code/${localeCode}`);
    }

}
